export function createGateValidate(gate){
    var result = true;

    result = validateName(gate.name);    
    result = validateIsEntry(gate.is_entry);
    result = validateIsRfid(gate.is_rfid);
    result = validateWarehouseId(gate.warehouse_id)
    
    return result;
}

function validateWarehouseId(warehouse_id){    
    if(Number.isInteger(warehouse_id)) return true;
    else return false;
}

function validateName(name){
    if(typeof customer === 'string' && name.trim() !== '') return true;
    else return false;
}

function validateIsEntry(is_entry){
    if(typeof is_entry === 'boolean' || is_entry == null) return true;
    else return false;
}

function validateIsRfid(is_rfid){
    if(typeof is_rfid === 'boolean' || is_rfid == null) return true;
    else return false;
}